// Welcome.jsx
import React, { useEffect, useRef, useState } from 'react';
import './welcome.css';
import Aurora from '../Aurora/Aurora';
import { AiOutlineSearch, AiOutlineClose } from 'react-icons/ai';
import { fetchProducts } from '../../services/getProducts';
import { useNavigate } from 'react-router-dom';


const Welcome = ({
                     title = '¡Bienvenido a Volteon!',
                     subtitle = '',
                 }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [products, setProducts] = useState([]);
    const containerRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting);
            },
            { threshold: 0.1 }
        );

        if (containerRef.current) observer.observe(containerRef.current);
        return () => {
            if (containerRef.current) observer.unobserve(containerRef.current);
        };
    }, []);

    useEffect(() => {
        const loadProducts = async () => {
            const data = await fetchProducts();
            setProducts(data);
        };
        loadProducts();
    }, []);

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchValue(value);
        if (value.length >= 1) {
            const results = products.filter((product) =>
                product.label.toLowerCase().includes(value.toLowerCase())
            );
            setFilteredProducts(results.slice(0, 5));
        } else {
            setFilteredProducts([]);
        }
    };

    const clearSearch = () => {
        setSearchValue('');
        setFilteredProducts([]);
    };

    const handleProductClick = (id, name) => {
        const productLink = getProductPageLink(id, name);
        navigate(productLink);
    };

    function getProductPageLink(product_id, product_name) {
        const encodedProductName = encodeURIComponent(product_name);
        return `/products/${product_id}-${encodedProductName}`;
    }

    return (
        <div
            className={`welcome-container ${isVisible ? 'visible' : ''}`}
            ref={containerRef}
        >
            <div className='welcome-image'>
                <img src={'/images/leon.png'} alt='León'/>
                <div className='image-overlay'></div>
            </div>
            <div className='welcome-content'>
                <h1>{title}</h1>
                {subtitle && <p>{subtitle}</p>}
            </div>
            {/* Search UI omitted for brevity; stays unchanged */}
        </div>
    );
};

export default Welcome;

